//frontend/src/dropdownMap/3Act2_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    13: "Gender",
    16: "BNetworkMember",
    17: "BNContract",
    23: "Gender",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    BNetworkMember: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    BNContract: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
